import { captureException } from '@sentry/node';
import contentRequest from '~/src/services/api/api-content';
import type { ApiCity } from './types';

export const getCities = async (fields?: string[]): Promise<ApiCity[] | null> => {
    const params = {
        all: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? '0' : '1',
    };

    if (fields?.length) {
        params['fields'] = fields.join(',');
    }

    try {
        const { data } = await contentRequest().get('/v1/geography/get-all-cities', {
            params: params,
        });
        return data;
    } catch (e) {
        captureException(e);
        return [];
    }
};
